import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyvehiclesComponent } from './myvehicles/myvehicles.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AddVehicleComponent } from './add-vehicle/add-vehicle.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { VehicleFoundComponent } from './vehicle-found/vehicle-found.component';
import { MatIconModule } from '@angular/material/icon';
import { MyVehicleContainerComponent } from './my-vehicle-container/my-vehicle-container.component';
import { MyVehicleModuleRoutingModule } from './my-vehicle.routing.module';
import { VehicleDetailComponent } from './vehicle-detail/vehicle-detail.component';
import { ReportStolenVehicleComponent } from './report-stolen-vehicle/report-stolen-vehicle.component';
import { RemoveVehicleComponent } from './remove-vehicle/remove-vehicle.component';
import { RemoveVehicleConfirmationComponent } from './remove-vehicle-confirmation/remove-vehicle-confirmation.component';
import { UnlockFeaturesComponent } from './trials/unlock-features/unlock-features.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { ComplimentaryFeaturesComponent } from './trials/complimentary-features/complimentary-features.component';
import { SubsriptionDetailComponent } from './vehicle-detail/subsription-detail/subsription-detail.component';
import { SubscribedComplimentaryFeaturesComponent } from './vehicle-detail/subscribed-complimentary-features/subscribed-complimentary-features.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { SelectSubscriptionComponent } from './manage-subscription/select-subscription/select-subscription.component';
import { SubscriptionContactInfoComponent } from './manage-subscription/subscription-contact-info/subscription-contact-info.component';
import { SubscriptionPaymentMethodComponent } from './manage-subscription/subscription-payment-method/subscription-payment-method.component';
import { SubscriptionCreatePinComponent } from './manage-subscription/subscription-create-pin/subscription-create-pin.component';
import { SubscriptionSummaryComponent } from './manage-subscription/subscription-summary/subscription-summary.component';
import { SubscriptionItemComponent } from './manage-subscription/select-subscription/subscription-item/subscription-item.component';
import { SharedModule } from '../shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EditSubscriptionContactInfoComponent } from './vehicle-detail/edit-subscription-contact-info/edit-subscription-contact-info.component';
import { TermsOfServiceComponent } from '../shared/terms-of-service/terms-of-service.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { ManageSubscriptionComponent } from './manage-subscription/manage-subscription.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { SubscriptionOptionComponent } from './manage-subscription/subscription-option/subscription-option.component';
import { CancelTrialDialogComponent } from './manage-subscription/subscription-option/cancel-trial-dialog/cancel-trial-dialog.component';

@NgModule({
  declarations: [
    MyvehiclesComponent,
    AddVehicleComponent,
    VehicleFoundComponent,
    MyVehicleContainerComponent,
    VehicleDetailComponent,
    ReportStolenVehicleComponent,
    RemoveVehicleComponent,
    RemoveVehicleConfirmationComponent,
    UnlockFeaturesComponent,
    ComplimentaryFeaturesComponent,
    SubsriptionDetailComponent,
    SubscribedComplimentaryFeaturesComponent,
    ManageSubscriptionComponent,
    TermsOfServiceComponent,
    SubscriptionOptionComponent,
    CancelTrialDialogComponent,
  ],
  imports: [
    MyVehicleModuleRoutingModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatGridListModule,
    MatRadioModule,
    MatStepperModule,
    SharedModule,
    MatTabsModule,
    MatListModule,
    MatAutocompleteModule,
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ],
  exports: [MyvehiclesComponent],
})
export class MyVehicleModule {}
